module.exports = __webpack_public_path__ + "static/media/icon-t7.e80dee75.png";